import { extendTailwindMerge } from 'tailwind-merge';

// AIDEV-NOTE: custom animations from tailwind.config.js must be listed here, or cn() keeps both
// tw-animate-pulse and the override and the winner depends on stylesheet order.
const tailwindMergeConfig = {
  classGroups: {
    animate: [{ animate: ['skeleton-pulse', 'sync-dot'] }],
  },
  prefix: 'tw-',
};

const twMerge = extendTailwindMerge(tailwindMergeConfig);

export default twMerge;
